import DialogTitle from "@mui/material/DialogTitle";
import {Box, Button, IconButton} from "@mui/material";
import {CheckCircleOutlined, Close, SaveOutlined} from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import React, {useCallback, useMemo, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentComponent from "../../../common/components/Shared/DialogContentComponent";
import Generales from "../../../common/components/Shared/Generales";
import useApi from "../../../api/useApi";
import useNotification from "../../../common/components/hooks/useNotification";
import {useAuth} from "../../../common/security/AuthProvider";
import FieldFileInputsGroup from "../../../common/components/forms/fields/FieldFileInputsGroup";

const ComplementoPago = ({complementoOpen,onClose, data}) => {
    const {t} = useTranslation();
    const open = complementoOpen;
    const apiComplemento = useApi('configuracion/Facturas');
    const notification = useNotification();
    const {esProveedor} = useAuth();
    const [cargandoFactura, setCargandoFactura] = useState(false);
    const fileInputsInitialState = useMemo(() => ({ xml: data?.rutaXml, pdf: data?.rutaPdf }), [data]);
    const [fileInputs, setFileInputs] = useState(fileInputsInitialState);

    const closeLogModal = () => {
        onClose();
    }

    const onGuardarButtonClicked = useCallback(async () => {
        if (typeof data?.rutaXml === "string" &&
            data?.rutaXml.length > 0) {
            return;
        }
        if (fileInputs.xml)
        {
            const formData = new FormData();
            for (let i =0;i<data.length; i++)
            {
                formData.append('facturaIds['+i+']',data[i].id);
            }
            formData.append('complemento', fileInputs.xml);
            if (fileInputs.pdf)
                formData.append('complementoPdf', fileInputs.pdf);
            try {
                setCargandoFactura(true);
                await apiComplemento.post('complemento', formData);
                setCargandoFactura(false);
                onClose();
                await notification.info(t('Complemento cargado'));
            }catch (e){
                notification.error('Error de validación en archivo XML')
            }
        }
    }, [data, fileInputs, apiComplemento, onClose, notification, t]);

    const onFieldInputChanged = (file, field) =>
        setFileInputs(inputs => ({...inputs, [field]: file}));

    return(
        <>
            <Dialog
                open={open}
                fullWidth={true}
                maxWidth={'md'}>
                <DialogTitle marginInline={4} marginTop={2} fontWeight={'bold'}>
                    <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                        <Box sx={{gridRow: "1", gridColumn: "1/9"}}>
                            { t(`Complemento de Pago`)}
                        </Box>
                    </Box>

                    <IconButton sx={{position: 'absolute', right: 8, top: 8}} onClick={() => closeLogModal()}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{marginInline: 4}}>

                    {esProveedor && <FieldFileInputsGroup
                        mode="horizontal"
                        readOnly={(typeof data?.rutaXml === "string" && data?.rutaXml.length > 0) || cargandoFactura}
                        fields={[
                            {
                                field: "xml",
                                label: "Archivo XML",
                                allowedFileExtensions: [".xml"],
                                defaultValue: fileInputs?.xml,
                                iconOnly: true,
                                onChange: onFieldInputChanged,
                            },
                            {
                                field: "pdf",
                                label: "Archivo PDF",
                                allowedFileExtensions: [".pdf"],
                                defaultValue: fileInputs?.pdf,
                                iconOnly: true,
                                onChange: onFieldInputChanged,
                            },
                        ]}
                        actionComponent={
                            <Button
                                variant="outlined"
                                color="info"
                                component="button"
                                startIcon={<SaveOutlined />}
                                onClick={onGuardarButtonClicked}
                            >
                                Guardar Archivos
                            </Button>
                        }
                    />}

                    <DialogContentComponent>

                        <Generales >
                            {esProveedor ?
                                <>
                                    <h3>
                                        {t('NOTA')}
                                    </h3>
                                    <label>
                                        {t('Puedes cargar un complemento de pago correspondiente a múltiples facturas y, mediante la lectura del archivo .xml, se actualizarán automáticamente los estatus de las facturas correspondientes')}
                                    </label>
                                </>
                                :
                                <Box display={'inline'}>

                                    <FieldFileInputsGroup
                                        mode="horizontal"
                                        readOnly={(typeof data?.rutaXml === "string" && data?.rutaXml.length > 0) || cargandoFactura}
                                        fields={[
                                            {
                                                field: "xml",
                                                label: "Archivo XML",
                                                allowedFileExtensions: [".xml"],
                                                defaultValue: fileInputs?.xml,
                                                iconOnly: true,
                                                onChange: onFieldInputChanged,
                                            }
                                        ]}
                                        actionComponent={
                                            <Button
                                                variant="outlined"
                                                color="info"
                                                component="button"
                                                startIcon={<SaveOutlined />}
                                                onClick={onGuardarButtonClicked}
                                            >
                                                Guardar Archivos
                                            </Button>
                                        }
                                    />
                                </Box>
                            }

                        </Generales>
                    </DialogContentComponent>
                    <DialogActions>
                        <Box sx={{display: "grid", gridAutoColumns: "1fr", width: "100%", gap: "10px"}}>
                            {esProveedor ?
                                <>
                                    <Box color={'black'} fontWeight={'bold'} sx={{gridRow: "1", gridColumn: "8/9"}} >
                                        <Button  variant="outlined" color={'inherit'} startIcon={<Close/>}
                                                 //disabled={!(data.estatusId === estatusProcesoFacturacion.PendienteCargaFactura)}
                                                 onClick={() => closeLogModal()}
                                            >
                                            {t('CANCELAR')}
                                        </Button>
                                    </Box>
                                    <Box textAlign={'right'} color={'black'} fontWeight={'bold'}
                                         sx={{gridRow: "1", gridColumn: "9/10"}}>
                                        <Button  variant="outlined" color={'success'} startIcon={<CheckCircleOutlined/>}
                                                 //disabled={!(data.estatusId === estatusProcesoFacturacion.PendienteCargaFactura)}
                                                 onClick={onGuardarButtonClicked}
                                        >
                                            {t('GUARDAR')}
                                        </Button>
                                    </Box>
                                </>
                                :
                                <></>}
                        </Box>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ComplementoPago;
